import axios from "axios";
import appConfig from "configs/app.config";
import { REQUEST_HEADER_AUTH_KEY, TENANT_HEADER } from "constants/api.constant";
import { PERSIST_STORE_NAME, SCT_KEY } from "constants/app.constant";
import deepParseJson from "utils/deepParseJson";
import store from "../store";
import { onSignOutSuccess } from "../store/auth/sessionSlice";

const unauthorizedCode = [401];
let tenantId = process.env.REACT_APP_TENANT_ID;

const BaseService = axios.create({
  timeout: 60000,
  baseURL: appConfig.apiPrefix,
});

BaseService.interceptors.request.use(
  (config) => {
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);

    const loginToken = localStorage.getItem("token");
    const accessToken = persistData.auth.session.token.payload;
    config.headers[TENANT_HEADER] = tenantId;
    if (accessToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${accessToken}`;
    } else if (loginToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${loginToken}`;
    }

    config.headers[SCT_KEY] = localStorage.getItem(SCT_KEY);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response && unauthorizedCode.includes(response.status)) {
      store.dispatch(onSignOutSuccess());
    }

    return Promise.reject(error);
  }
);

export default BaseService;
